<template>
  <div class="dashboard-container">
    <div class="chart-container">
      <card-componet class="first">
        <alert-weekly-line :options="{responsive: false, maintainAspectRatio: false}"
                          :width="1000"
                          :height="280"
                          :data="chartData"></alert-weekly-line>
        <div class="search-container">
          <search-input class="search-input"
                        type="text"
                        v-model="companyName"
                        placeholder="Search" />
          <secondary-button @click.native="getSmsReports"
                            class="secondary-button">Filter</secondary-button>
        </div>
        <div class="resellers-table table-header">
          <div><span>Company</span></div>
          <div><span>Date</span></div>
          <div><span>SMS</span></div>
        </div>
        <div v-for="(alert, k) in alerts"
             :key="k"
             class="resellers-table table-body">
          <div><span>{{alert.companyName}}</span></div>
          <div><span>{{alert.date}}</span></div>
          <div><span>{{alert.smsCount}}</span></div>
        </div>
        <p @click="showMore"
           class="pagination-link">Show more</p>
      </card-componet>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    AlertWeeklyLine: () => import("@/components/Charts/Alert/AlertWeeklyLine"),
    CardComponet: () => import("@/components/CardComponent.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue")
  },
  data: () => ({
    alerts: [],
    perPage: 10,
    companyName: "",
    resellers: [
      { company: "Nellie Ferguson", date: "29 Apr 2018", sms: 97322 },
      { company: "Lou Haynes", date: "06 Nov 2018", sms: 97322 },
      { company: "Nellie Ferguson", date: "29 Apr 2018", sms: 97322 }
    ],
    arraWeeks: [],
    total: null,
  }),
  computed: {
    chartData() {
      var date = new Date(2019,0);
      let month = format(date, "M");
      let year = date.getFullYear();
      let last_day = this.daysInMonth(month, year);
      console.log("this.arraWeeks", year,"::::::::::::::::::::", month, ":::::::", last_day)
      var count = last_day == 28 ? this.weeksCount(year, month)-1 : this.weeksCount(year, month)+1
      var arraWeeks = new Array(count);
      arraWeeks.fill(0);
      arraWeeks = arraWeeks.map((i,k) => {
        // return k == 0 ? format(new Date(year, month-1, '01'), 'D MMM YYYY') : format(new Date(year, month-1, 7*k>31 ? 31 : 7*k), 'D MMM YYYY');
        return k == 0 ? '1st' : 7*k+1 > last_day ? last_day + this.nth(last_day) : 7*k+1 + this.nth(7*k+1); 
      });
      var smsCountValues = new Array(count);
      smsCountValues.fill(0);
      console.log("this.arraWeeks", arraWeeks)
      this.alerts.map((item) => {
        var weekOfMonth = this.getWeekOfMonth(item.date);
        console.log("weekOfMonth",weekOfMonth);
        smsCountValues[weekOfMonth] += item.smsCount;
        console.log("smsCountValues---->", smsCountValues)
      });
      return {arraWeeks, smsCountValues}
    }
  },
  created() {
    this.getSmsReports();
  },
  methods: {
    nth(n){return["st","nd","rd"][((n+90)%100-10)%10-1]||"th"},
    getWeekOfMonth(date) {
      // var thiss = new Date(date);
      // var dowOffset = 0; //typeof(dowOffset) == 'int' ? dowOffset : 0; //default dowOffset to zero
      // var newYear = new Date(thiss.getFullYear(),0,1);
      // var day = newYear.getDay() - dowOffset; //the day of week the year begins on
      // day = (day >= 0 ? day : day + 7);
      // var daynum = Math.floor((thiss.getTime() - newYear.getTime() - 
      // (thiss.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
      // var weeknum;
      // //if the year starts before the middle of a week
      // if(day < 4) {
      //     weeknum = Math.floor((daynum+day-1)/7) + 1;
      //     if(weeknum > 52) {
      //         let nYear = new Date(thiss.getFullYear() + 1,0,1);
      //         let nday = nYear.getDay() - dowOffset;
      //         nday = nday >= 0 ? nday : nday + 7;
      //         /*if the next year starts before the middle of
      //           the week, it is week #1 of that year*/
      //         weeknum = nday < 4 ? 1 : 53;
      //     }
      // }
      // else {
      //     weeknum = Math.floor((daynum+day-1)/7);
      // }
      // return weeknum;

      var thiss = new Date(date);

      var dayOfMonth = thiss.getDay();
      var month = thiss.getMonth();
      var year = thiss.getFullYear();
      var checkDate = new Date(year, month, thiss.getDate());
      var checkDateTime = checkDate.getTime();
      var currentWeek = 0;

      for (var i = 1; i < 32; i++) {
          var loopDate = new Date(year, month, i);

          if (loopDate.getDay() == dayOfMonth) {
              currentWeek++;
          }

          if (loopDate.getTime() == checkDateTime) {
              return currentWeek;
          }
      }
    },
    weeksCount (y, m) {
      // var firstOfMonth = new Date(year, month_number - 1, 1);
      // var day = firstOfMonth.getDay() || 6;
      // day = day === 1 ? 0 : day;
      // if (day) { day-- }
      // var diff = 7 - day;
      // var lastOfMonth = new Date(year, month_number, 0);
      // var lastDate = lastOfMonth.getDate();
      // if (lastOfMonth.getDay() === 1) {
      //   diff--;
      // }
      // var result = Math.ceil((lastDate - diff) / 7);
      // return result + 1;

      var first = new Date(y, m,1).getDay();      
      var last = 32 - new Date(y, m, 32).getDate(); 

      // logic to calculate number of weeks for the current month
      return Math.ceil( (first + last)/7 ); 
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    transformAlerts(i, k) {
      return {
        companyName: i.company_name,
        date: format(i.date, "D MMM YYYY"),
        smsCount: i.sms_count
      };
    },
    transformChartData({ smsCount }, k) {
      return {
        smsCount
      };
    },
    showMore() {
      this.perPage = this.perPage + 10;
      
      if(this.total < this.perPage) return

      let date = new Date();
      let month = format(date, "MM");
      let year = date.getFullYear();
      let last_day = this.daysInMonth(month, year);
      this.$store
        .dispatch("getSmsReport", {
          per_page: this.perPage,
          company_name: this.companyName,
          year: year,
          month: month,
          last_day: last_day
        })
        .then(res => {
          this.total = res.data.payload.total;
          this.alerts = res.data.payload.items.map(this.transformAlerts);
        });
    },
    getSmsReports() {
      let date = new Date();
      let month = format(date, "MM");
      let year = date.getFullYear();
      let last_day = this.daysInMonth(month, year);
      this.$store
        .dispatch("getSmsReport", {
          per_page: this.perPage,
          company_name: this.companyName,
          last_day: last_day,
          month: month,
          year: year
        })
        .then(res => {
          this.alerts = res.data.payload.items.map(this.transformAlerts);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-container {
  padding: 20px;
  .chart-container {
    display: flex;
    margin-bottom: 20px;
    .search-container {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      .search-input {
        height: 36px;
        width: 417px;
      }
      .secondary-button {
        height: 36px;
        width: 80px;
      }
    }
    .resellers-table {
      height: 37px;
      display: flex;
      align-items: center;
      padding: 0 15px 0 15px;
      box-shadow: inset 0 -1px 0 0 #dfe3e8;
      div {
        width: 15%;
      }
    }
    .table-header {
      color: #212b36;
      font-family: "Helvetica Neue";
      font-size: 14px;
      font-weight: 600;
      line-height: 16px;
    }
    .table-body {
      color: #212b36;
      font-family: "Helvetica Neue";
      font-size: 14px;
      line-height: 20px;
      justify-content: left;
      .status {
        border: 2px solid #ffffff;
        border-radius: 100px;
        box-sizing: border-box;
        padding: 2px 8px 2px 8px;
        width: fit-content;
        font-family: "Helvetica Neue";
        font-size: 13px !important;
        line-height: 16px;
      }
    }
    .pagination-link {
      cursor: pointer;
      margin-top: 10px;
      text-align: center;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 13px;
      line-height: 15px;
    }
  }
}
</style>

